import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { DecisionsComponent } from './decisions/decisions.component';
import { DocumentsComponent } from './documents/documents.component';
import { ProceedingsComponent } from './proceedings/proceedings.component';
import { ResultsGridComponent } from './components/results-grid/results-grid.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { FilterTagsComponent } from './components/filter-tags/filter-tags.component';
import { FacetComponent } from './components/facets/facet/facet.component';
import { FacetSearchPipe } from './components/facets/facet-search.pipe';
import { FacetTagsComponent } from './components/facet-tags/facet-tags.component';
import { SafeHtmlPipe } from './components/results-grid/safe-html.pipe';
import { TextEllipsisPipe } from './pipes/text-ellipsis.pipe';
import { TextTruncateComponent } from './components/text-truncate/text-truncate.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

@NgModule({
  imports: [
    SharedModule,
    SearchRoutingModule,
    NgxTrimDirectiveModule
  ],
  declarations: [
    SearchComponent,
    DecisionsComponent,
    DocumentsComponent,
    ProceedingsComponent,
    ResultsGridComponent,
    PaginatorComponent,
    FilterTagsComponent,
    FacetComponent,
    FacetSearchPipe,
    FacetTagsComponent,
    SafeHtmlPipe,
    TextEllipsisPipe,
    TextTruncateComponent
  ]
})
export class SearchModule { }
